import { API_LOCATION_URL } from 'infrastructure/config';
import { IGetInput, IGetResponse, ICompanySurveyClient } from 'interfaceAdapter/gatewaySchemas/ICompanySurveyClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');

export class CompanySurveyClient implements ICompanySurveyClient {
    async get(input: IGetInput): Promise<IGetResponse> {
        const { token, matchId } = input;
        const PATH = `${API_LOCATION_URL}/company/survey?match_id=${matchId}`;
        const method = 'GET';

        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-C': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        try {
            const response = await fetch(PATH, {
                method,
                headers,
            });
            return response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
